import {Configuration, SessionApi} from "@/rest";
import {AppModule} from "@/store/modules/app";

export default function resolveSession(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        let params = new URLSearchParams(window.location.search)
        let sessionId = params.get("session")
        let productId = params.get("productId")
        window.console.log("productId", productId)
        let sessionApi = new SessionApi(
            new Configuration({ basePath: '/rest'})
        )
        sessionApi.getSession( { sessionId: sessionId! } ).then(
            (value) => {
                AppModule.SET_SESSION(value)
                if(productId)
                    AppModule.SetProductID(productId)
                resolve()
            },
            (reason) => {
                window.console.log(reason)
                reject()
            });
        let productVariant = params.get("productVariant")
        if(productVariant !== null) {
            AppModule.SetProductVariant(productVariant);
        }
    });
}
